import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../graphql/GraphQlProvider';
import {gqlDocument} from './getDocument.api';
import {WcvDocument} from '../../graphql/documents.datatypes';

export interface UpdateDocumentInput {
    data: {
        __typename: undefined,
        user: undefined,
        targetResource: undefined,
        targetGroup: undefined,
        targetGroupMember: undefined,
        completed_documents: undefined,
        overdueGroupMembers: undefined,

        id: number
        parent_document_id?: number
        user_id?: number
        type?: number
        type_id?: number
        title?: string
        description?: string
        url?: string
        available_for_download?: boolean
        has_completion_date?: boolean
        completion_date?: string
        verified?: boolean
        tour_role?: number
    }
}

interface UpdateDocumentData {
    __typename?: string,
    updateDocument: WcvDocument
}

export const UPDATE_DOCUMENT_MUTATION = gql`
    mutation updateDocument($data: UpdateDocumentInput!) {
        updateDocument(data: $data) {
            ${gqlDocument}
        }
    }
`;

export const updateDocument = () => useMutation<UpdateDocumentData, UpdateDocumentInput>(
    UPDATE_DOCUMENT_MUTATION,
    {
        update: updateCacheByType('Document'),
    }
);

export default updateDocument;